import React, { createContext, useContext, ReactNode } from 'react'
import {HeaderAction, HeaderActionsContextType} from './interface'

const HeaderActionsContext = createContext<HeaderActionsContextType>({
  headerActions: [],
  setHeaderActions: () => {}
})

export const HeaderActionsProvider = ({ children }: { children: ReactNode }) => {
  const [headerActions, setHeaderActions] = React.useState<HeaderAction[]>([])

  return (
    <HeaderActionsContext.Provider value={{ headerActions, setHeaderActions }}>
      {children}
    </HeaderActionsContext.Provider>
  )
}

export const useHeaderActions = () => useContext(HeaderActionsContext)